(function () {
  function initSubscriptionDefault() {
    // Find all purchase option radio inputs
    var radios = document.querySelectorAll('input[name="selling_plan"], input[type="radio"][name*="selling"]');
    if (!radios.length) return;

    // Find and select the one-time purchase option (selling_plan value of "" or "0")
    radios.forEach(function (radio) {
      if (radio.value === '' || radio.value === '0') {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Also clear the hidden selling_plan input on the add-to-cart form
    var form = document.querySelector('form[action="/cart/add"]');
    if (form) {
      var hiddenPlan = form.querySelector('input[name="selling_plan"]');
      if (hiddenPlan && hiddenPlan.type === 'hidden') {
        hiddenPlan.value = '';
      }
    }
  }

  // Run after widget loads (widget injects via JS so we need a delay + observer)
  function waitForWidget() {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      var radios = document.querySelectorAll('input[name="selling_plan"]');
      if (radios.length) {
        clearInterval(interval);
        initSubscriptionDefault();
      }
      if (attempts > 20) clearInterval(interval); // give up after ~4 seconds
    }, 200);
  }

  // Also guard against selling_plan being re-added on form submit
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.action.indexOf('/cart/add') === -1) return;

    // Check if one-time radio is selected
    var oneTimeRadio = form.querySelector('input[name="selling_plan"][value=""], input[name="selling_plan"][value="0"]');
    if (oneTimeRadio && oneTimeRadio.checked) {
      var hidden = form.querySelector('input[name="selling_plan"][type="hidden"]');
      if (hidden) hidden.value = '';
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForWidget);
  } else {
    waitForWidget();
  }
})();